import React, { useState } from 'react';
import * as Icons from '@seismic/icons';
import { downloadFile, isUrl, supportDownload, canDownloadInDevice, supportMultipleDownloads, getDownloadUrl, getContentDownloadAssets } from '../../commonUtil/util';
import UxEventService from '../../service/UxEventService';
import { isPresentationMode } from '../../commonUtil/presentationUtil';
import { DOWNLOAD_MODE, KeyBoardAction } from '../../commonUtil/constants';
import FormatsDropdown from './formatsDropdown';

export default function ActionIcon(props) {
    const { canDownload, content, className, currentManifest, brandingHilightColor,
        renderCustomIcon, contextType, dropdownPlacement, downloadFormats, downloadAssets, enableLiveSendDownloadOptions } = props;
    const { format, id } = content || {};

    const [downloadIconHoverColor, setDownloadIconHoverColor] = useState('#536872');
    const [showDownloadDropdown, setShowDownloadDropdown] = useState(false);
    const downloadUrls = getContentDownloadAssets(downloadAssets, content);
    const isMultiDownload = enableLiveSendDownloadOptions && downloadFormats === DOWNLOAD_MODE.PDFOrOriginal && downloadUrls.length > 1 && supportMultipleDownloads(format);
    const currentDownloadUrl = getDownloadUrl(format, downloadFormats, downloadUrls);

    const onDownload = (item) => {
        setShowDownloadDropdown(false);
        const { downloadUrl, assetType } = item || {};
        if (downloadUrl) {
            downloadFile({ downloadUrl, downloadFormat: assetType, contentId: id });
            UxEventService.navigateViewEvent({ Context: contextType, Target: 'Download' });
        }
    };

    const handleIconClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isUrl(format)) {
            window.open(currentManifest.Url, '_blank');
            UxEventService.navigateViewEvent({ Context: contextType, Target: 'Open Link' });
            return;
        }

        if (supportDownload(format)) {
            if (isMultiDownload) {
                setShowDownloadDropdown(!showDownloadDropdown);
                return;
            }

            if (currentDownloadUrl && currentDownloadUrl.downloadUrl) {
                onDownload(currentDownloadUrl);
            } else if (currentManifest && currentManifest.DownloadUrl) {
                // TODO: remove get download url form manifest after the download option is released
                onDownload({ downloadUrl: currentManifest.DownloadUrl });
            }
        }
    };

    const handleOnKeydown = (e) => {
        if (e.keyCode === KeyBoardAction.enter) {
            handleIconClick(e);
        }
    };

    const handleMouseEnterIcon = () => {
        setDownloadIconHoverColor(brandingHilightColor);
    };

    const handleMouseLeaveIcon = () => {
        setDownloadIconHoverColor('#536872');
    };

    const renderIcon = () => {
        if (isUrl(format) && currentManifest && currentManifest.Url) {
            return <Icons.OpenIcon className="icon-open-link" style={{ color: downloadIconHoverColor }} />;
        } else if (canDownload && supportDownload(format) && canDownloadInDevice()) {
            if (isMultiDownload) {
                return <Icons.MoreIcon className="icon-more" style={{ color: downloadIconHoverColor }} />;
            }

            // TODO: remove get download url form manifest after the download option is released
            const downloadUrl = enableLiveSendDownloadOptions ? currentDownloadUrl && currentDownloadUrl.downloadUrl : currentManifest && currentManifest.DownloadUrl;
            if (downloadUrl) {
                return <Icons.DownloadIcon className="icon-download" style={{ color: downloadIconHoverColor }} />;
            }
        }

        return null;
    };

    if (renderCustomIcon && renderCustomIcon()) {
        return (<div className={className}>
            {renderCustomIcon({ color: downloadIconHoverColor })}
        </div>);
    }

    return (
        !isPresentationMode() && renderIcon() && <div className={className}
            role="button"
            tabIndex="0"
            aria-label={isUrl(format) ? 'Open link' : `Download ${content.name}`}
            onClick={handleIconClick}
            onKeyDown={handleOnKeydown}
            onMouseEnter={handleMouseEnterIcon}
            onMouseLeave={handleMouseLeaveIcon}>
            {renderIcon()}
            {showDownloadDropdown && <FormatsDropdown
                className="action-download-dropdown"
                downloadUrls={downloadUrls}
                originalFormat={format}
                onClick={onDownload}
                placement={dropdownPlacement || ''}
                onClose={() => { setShowDownloadDropdown(false); }} />}
        </div>
    );
}
